/**
 * Customizer Dialog
 */

import React from 'react'
import {
	Dialog,
	DialogContent,
	DialogTitle,
	Button,
	Typography,
	Divider,
	DialogActions,
	RadioGroup,
	Radio,
	FormControlLabel,
	FormControl,
	TextField,
	Box,
} from '@mui/material'
import LoadingButton from '@mui/lab/LoadingButton'
/** FONTS */
import '@fontsource/roboto'
import '@fontsource/roboto-flex'
import '@fontsource/open-sans'
import '@fontsource/noto-sans'
import '@fontsource/noto-serif'
/** TYPES */
import { availablePalettes } from '@/layout/colors'

interface CustomizerProps {
	open: boolean
	onClose: () => void
	onSuccess?: () => void
}

const Customizer = (props: CustomizerProps) => {
	const [open, setOpen] = React.useState(props.open)
	const [loading, setLoading] = React.useState(false)

	const [text, setText] = React.useState('ЭН БИ СИ ХХК Биллин системд тавтай морилно уу.')
	const [fonts, setFonts] = React.useState(['Roboto', 'Roboto Flex', 'Open Sans', 'Noto Sans', 'Noto Serif'])
	const [chosenFonts, setChosenFonts] = React.useState(
		localStorage.getItem('fontFamily') === `'Roboto', sans-serif`
			? 'Roboto'
			: localStorage.getItem('fontFamily') === `'Roboto Flex', sans-serif`
			? 'Roboto Flex'
			: localStorage.getItem('fontFamily') === `'Open Sans', sans-serif`
			? 'Open Sans'
			: localStorage.getItem('fontFamily') === `'Noto Sans', sans-serif`
			? 'Noto Sans'
			: 'Noto Serif'
	)

	const [chosenPalette, setChosenPalette] = React.useState(localStorage.getItem('colorPalette') || 'default')

	const [fontFamily, setFontFamily] = React.useState(`'Roboto', sans-serif`)

	React.useEffect(() => {
		if (chosenFonts === 'Roboto') {
			setFontFamily(`'Roboto', sans-serif`)
		} else if (chosenFonts === 'Roboto Flex') {
			setFontFamily(`'Roboto Flex', sans-serif`)
		} else if (chosenFonts === 'Open Sans') {
			setFontFamily(`'Open Sans', sans-serif`)
		} else if (chosenFonts === 'Noto Sans') {
			setFontFamily(`'Noto Sans', sans-serif`)
		} else if (chosenFonts === 'Noto Serif') {
			setFontFamily(`'Noto Serif', serif`)
		}
	}, [chosenFonts])

	React.useEffect(() => {
		setOpen(props.open)
	}, [props.open])

	const handleClose = () => {
		setOpen(false)
		setTimeout(() => {
			props.onClose()
		}, 300)
	}

	const handleSave = () => {
		// save choosen font to local storage
		setLoading(true)

		localStorage.setItem('fontFamily', fontFamily)
		localStorage.setItem('colorPalette', chosenPalette)

		setTimeout(() => {
			setLoading(false)
			props.onSuccess && props.onSuccess()
			handleClose()
		}, 1000)
	}

	return (
		<Dialog open={open} maxWidth="md" fullWidth>
			<DialogTitle>
				<Typography variant="h4">Харагдац өөрчлөх</Typography>
			</DialogTitle>
			<DialogContent>
				<TextField
					fullWidth
					value={text}
					onChange={(e) => setText(e.target.value)}
					placeholder="Текстээ оруулна уу"
					margin="normal"
					label="Жишээ текст"
				/>
				<FormControl>
					<Typography variant="h6">Фонт сонгох</Typography>
					<RadioGroup row value={chosenFonts} onChange={(e) => setChosenFonts(e.target.value)}>
						{fonts.map((font, index) => (
							<FormControlLabel key={index} value={font} control={<Radio />} label={font} />
						))}
					</RadioGroup>
				</FormControl>
				<Box>
					<FormControl>
						<Typography variant="h6">Өнгө сонгох</Typography>
						<RadioGroup row value={chosenPalette} onChange={(e) => setChosenPalette(e.target.value)}>
							{availablePalettes.map((palette, index) => (
								<FormControlLabel
									key={index}
									value={palette.id}
									control={<Radio />}
									label={palette.name}
								/>
							))}
						</RadioGroup>
					</FormControl>
				</Box>
				<Divider sx={{ mt: 2 }} />
				<Box
					sx={{
						mt: 3,
						fontFamily: fontFamily,
					}}
				>
					<Typography variant="subtitle1" gutterBottom>
						Харагдац
					</Typography>
					<Typography
						variant="h5"
						sx={{
							fontFamily: fontFamily,
						}}
					>
						{text}
					</Typography>
					<Typography
						variant="h6"
						sx={{
							fontFamily: fontFamily,
						}}
					>
						{text}
					</Typography>
					<Typography
						variant="body1"
						sx={{
							fontFamily: fontFamily,
						}}
					>
						{text}
					</Typography>
					<Typography
						variant="body2"
						sx={{
							fontFamily: fontFamily,
						}}
					>
						{text}
					</Typography>
				</Box>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleClose}>Болих</Button>
				<LoadingButton variant="contained" color="primary" loading={loading} onClick={handleSave}>
					Хадгалах
				</LoadingButton>
			</DialogActions>
		</Dialog>
	)
}

export default Customizer
